import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  filterInputSelector: '[data-comp-select-filter-group-autocomplete-filter]',
  selectInputSelector: '[data-comp-select-filter-group-autocomplete-select]',
  dropdownSelector: '[data-comp-select-filter-group-autocomplete-dropdown]',
};

export default class SelectFilterGroupAutocomplete extends Component {
  static selector = '[data-comp-select-filter-group-autocomplete]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.filterInput = this.$container.querySelector(this.$options.filterInputSelector);
    this.selectInput = this.$container.querySelector(this.$options.selectInputSelector);
    this.dropdown = this.$container.querySelector(this.$options.dropdownSelector);

    this.initListeners();
  }

  initListeners() {
    if (!this.filterInput || !this.selectInput || !this.dropdown) return;

    // Show dropdown when input is clicked
    this.filterInput.addEventListener('click', () => {
      const allOptions = Array.from(this.selectInput.options);
      this.renderDropdown(allOptions);
    });

    this.filterInput.addEventListener('input', () => {
      const inputVal = this.filterInput.value.toLowerCase();

      const matchingOptions = Array.from(this.selectInput.options).filter(
        opt => opt.text.toLowerCase().includes(inputVal)
      );

      this.renderDropdown(matchingOptions);
    });

    document.addEventListener('click', e => {
      if (!this.$container.contains(e.target)) {
        this.hideDropdown();
      }
    });
  }

  renderDropdown(options) {
    this.dropdown.innerHTML = '';

    if (options.length === 0) {
      this.hideDropdown();
      return;
    }

    options.forEach(opt => {
      const div = document.createElement('div');
      div.className = 'autocomplete-item';
      div.textContent = opt.text;
      div.dataset.value = opt.value;

      div.addEventListener('click', () => {
        this.filterInput.value = opt.text;
        this.selectOption(opt.value);
        this.hideDropdown();
      });

      this.dropdown.appendChild(div);
    });

    this.dropdown.hidden = false;
  }

  selectOption(value) {
    Array.from(this.selectInput.options).forEach(opt => {
      opt.selected = opt.value === value;
    });

    // Manually dispatch the 'change' event
    const event = new Event('change', { bubbles: true });
    this.selectInput.dispatchEvent(event);
  }

  hideDropdown() {
    this.dropdown.hidden = true;
    this.dropdown.innerHTML = '';
  }
}
